// extracted by mini-css-extract-plugin
export default {"blog":"blogspage_blog__csujJ","blog__main":"blogspage_blog__main__dHxqH","container":"blogspage_container__ydbaC","pageLoader":"blogspage_pageLoader__3Eoks"};